const emailPattern = () => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
};

const websiteDomainPattern = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g

const phoneNumberPattern = /^\(?([2-9]\d{2})\)?-?([2-9]\d{2})-?(\d{4})$/

const isEmptyValue = /^(?!\\s*$).+/

const specialCharacterPattern = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/

const numberOrDotOnlyPattern = /[^.0-9]/g

const numberOnlyPattern = /^[0-9\b]+$/

const numberAndSpacePattern = /^[0-9\b ]+$/

const atLeastOneNumberPattern = /.*\d.*/
const atLeastOneUppercasePattern = /[A-Z]/
const atLeastOneLowercasePattern = /[a-z]/

const RegexAmount = /^(?!0\d)(\d+(\.\d{1,2})?)?$/

const decimalPatternWithoutLimit = /^\d*\.?\d*$/
const decimalPattern = /^(?!.*\.$)(?!^\.)\d{0,14}(\.\d{1,2})?$/

export const PatternValidate = {
  emailPattern,
  phoneNumberPattern,
  isEmptyValue,
  specialCharacterPattern,
  websiteDomainPattern,
  numberOrDotOnlyPattern,
  atLeastOneNumberPattern,
  atLeastOneUppercasePattern,
  atLeastOneLowercasePattern,
  numberOnlyPattern,
  numberAndSpacePattern,
  RegexAmount,
  decimalPattern,
  decimalPatternWithoutLimit,
}
